export default __webpack_public_path__ + "fcdc20bd127f0b7ff2c16aa44a14815a.jpeg";